import angular from "angular";

angular
    .module('app')
    .component('courseTrainingLessonError', {
        template: require('./course-training-lesson-error.html'),
        controller: ['$uibModal', '$http', '$sce', '$timeout', '$interval', controller],
        bindings: {
            'course': '<',
            'lesson': '<',
            'errorType': '@'
        }

    });

function controller($uibModal, $http, $sce, $timeout, $interval) {

    let $ctrl = this;

    $ctrl.l = null;

    $ctrl.$onInit = function () {
        $timeout(function () {
            $ctrl.lessons = [];
            $ctrl.course.chapters.forEach(function (chapter, chapterInd) {
                chapter.lessons.forEach(function (lesson, lessonInd) {
                    $ctrl.lessons.push(lesson);
                });
            });
        });
    }

    $ctrl.goToLesson = function () {
        if ($ctrl.l) {
            window.location = `/cabinet/courses/${$ctrl.course.id}/?lesson_id=${$ctrl.l.id}`;
        }
    };
}
